var lastArrayEach = require('../array/lastArrayEach')
var keys = require('../base/keys')

function lastObjectEach (obj, iterate, context) {
  lastArrayEach(keys(obj), function (key) {
    iterate.call(context, obj[key], key, obj)
  })
}

module.exports = lastObjectEach



//////////////////
// WEBPACK FOOTER
// ./~/_xe-utils@2.8.3@xe-utils/methods/object/lastObjectEach.js
// module id = 615
// module chunks = 106